import { render, staticRenderFns } from "./discount-category-table.vue?vue&type=template&id=5b0083fb&scoped=true&"
import script from "./discount-category-table.ts?vue&type=script&lang=ts&"
export * from "./discount-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./discount-category-table.scss?vue&type=style&index=0&id=5b0083fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0083fb",
  null
  
)

export default component.exports